import { ChangeEvent, useCallback } from 'react';

import { useFormikContext, FormikValues } from 'formik';

export function useCheckBoxField<T extends FormikValues, P>(fieldName: string) {
  const { setFieldValue, setFieldTouched, values } = useFormikContext<T>();

  const handleChange = useCallback(
    (event: ChangeEvent<HTMLInputElement>) => {
      setFieldTouched(fieldName, true);

      const newValue = event.target.value as P;
      const currentValues = (values[fieldName] || []) as Array<P>;

      if (currentValues.includes(newValue)) {
        setFieldValue(
          fieldName,
          currentValues.filter(value => value !== newValue),
        );
      } else {
        setFieldValue(fieldName, [...currentValues, event.target.value]);
      }
    },
    [fieldName, setFieldTouched, setFieldValue, values],
  );

  return handleChange;
}
